import React from 'react';
import '../css/Community.css';

const repos = [
  {
    name: 'face‑verify‑api',
    desc: 'FastAPI service for selfie‑based auth (face‑api.js).',
    stars: 142,
    link: 'https://github.com/ozXoz/face-verify-api'
  },
  {
    name: 'react‑jwt‑starter',
    desc: 'Plug‑and‑play JWT auth with React + Express.',
    stars: 289,
    link: 'https://github.com/ozXoz/react-jwt-starter'
  },
  {
    name: 'mongo‑etl‑scripts',
    desc: 'Handy aggregation ETL utilities for MongoDB Atlas.',
    stars: 67,
    link: 'https://github.com/ozXoz/mongo-etl-scripts'
  },
];

export default function Community() {
  return (
    <section id="community" className="community">
      <h2 className="community-title">Open‑Source</h2>

      <div className="repo-grid">
        {repos.map((r,i)=>(
          <a href={r.link} key={i} className="repo-card" target="_blank" rel="noreferrer">
            <h3>{r.name}</h3>
            <p>{r.desc}</p>
            <span>⭐ {r.stars}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
